import { useContext } from 'react';
import {
  ProgressContext,
  ProgressContextValue,
} from '../providers/ProgressProvider/ProgressProvider.interface';

export const useProgress = () =>
  useContext<ProgressContextValue>(ProgressContext);
